import { IMultiSimulationGroupRetrieved } from 'types/SimulationGroup/MultiSimulationGroup';

export const calculateMultiSimulationRunProgress = (multiSimulationGroup: IMultiSimulationGroupRetrieved): string => {
  const { simus_nb, failed_nb, server_error_nb, success_nb } = multiSimulationGroup;
  const finishedNumber = failed_nb + server_error_nb + success_nb;

  return finishedNumber + ' / ' + simus_nb;
};
